import _Form from "redux-form/es/Form";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { StripeSvgIcon } from 'swag-client-common/components/svg/stripe.svg';
import { PaymentInformation } from './payment-information';
import { PaymentDetailsBillingAddress } from './payment-details-billing-address';
import responsiveClasses from './payment-details.scss';
import fixedClasses from './payment-details-fixed.scss';
export class PaymentDetails extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleSubmit", () => {
      const {
        onSubmitClick
      } = this.props;
      onSubmitClick();
    });
  }
  render() {
    const {
      isDeliveryToCustomer,
      isSelectCardShown,
      isSaveAvailable,
      hideStripeLogo,
      isAutoPayCheckbox,
      isAutoPayCheckboxDisable,
      isCreditsAvailable,
      buyCreditsFlow,
      popupType,
      autopayLabel,
      disableWholeForm = false,
      isFixedStyles = false,
      onCardSelect,
      onPayByCredits,
      onCheckoutPayByCredits
    } = this.props;
    const classes = isFixedStyles ? fixedClasses : responsiveClasses;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Form, {
      onSubmit: this.handleSubmit,
      className: classes.form
    }, /*#__PURE__*/React.createElement(PaymentDetailsBillingAddress, {
      disableWholeForm: disableWholeForm,
      isDeliveryToCustomer: isDeliveryToCustomer,
      isFixedStyles: isFixedStyles
    }), /*#__PURE__*/React.createElement(PaymentInformation, {
      disableWholeForm: disableWholeForm,
      popupType: popupType,
      autopayLabel: autopayLabel,
      isSaveAvailable: isSaveAvailable,
      isSelectCardShown: isSelectCardShown,
      isAutoPayCheckbox: isAutoPayCheckbox,
      isAutoPayCheckboxDisable: isAutoPayCheckboxDisable,
      isCreditsAvailable: isCreditsAvailable,
      buyCreditsFlow: buyCreditsFlow,
      isFixedStyles: isFixedStyles,
      onCardSelect: onCardSelect,
      onPayByCredits: onPayByCredits || onCheckoutPayByCredits
    }), !hideStripeLogo && /*#__PURE__*/React.createElement("div", {
      className: classes.stripeIconWrapper
    }, /*#__PURE__*/React.createElement(StripeSvgIcon, null))));
  }
}